// src/pages/Ogledala.tsx
import CategoryPage from './CategoryPage';

const Ogledala = () => {
  const subcategories = [
    {
      title: "Freestanding Theater",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/freestanding"
    },
    {
      title: "Vanity",
      imageSrc: "https://images.unsplash.com/photo-1604014555037-e3abbf2d28b3?auto=format&fit=crop&q=80",
      url: "/ogledala/vanity"
    },
    {
      title: "Eclisse",
      imageSrc: "https://images.unsplash.com/photo-1616627052149-fe43712e633e?auto=format&fit=crop&q=80",
      url: "/ogledala/eclisse"
    },
    {
      title: "Tokyo Oval",
      imageSrc: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-oval"
    },
    {
      title: "Tokyo Round",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-round"
    },
    {
      title: "Tokyo Lente",
      imageSrc: "https://images.unsplash.com/photo-1493552152660-f915ab47ae9d?auto=format&fit=crop&q=80",
      url: "/ogledala/tokyo-lente"
    },
    {
      title: "Backlit",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/backlit"
    },
    {
      title: "Belt",
      imageSrc: "https://images.unsplash.com/photo-1552454799-ca5cfdc612c8?auto=format&fit=crop&q=80",
      url: "/ogledala/belt"
    },
    {
      title: "Cronografo",
      imageSrc: "https://images.unsplash.com/photo-1589798312990-ea8f06163835?auto=format&fit=crop&q=80",
      url: "/ogledala/cronografo"
    },
    {
      title: "TicTac",
      imageSrc: "https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80",
      url: "/ogledala/tictac"
    },
    {
      title: "Ordina Round",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/ordina-round"
    },
    {
      title: "Reflex Shelf",
      imageSrc: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80",
      url: "/ogledala/reflex-shelf"
    },
    {
      title: "Le Cuir",
      imageSrc: "https://images.unsplash.com/photo-1554302891-c04b1941b963?auto=format&fit=crop&q=80",
      url: "/ogledala/le-cuir"
    },
    {
      title: "Irene",
      imageSrc: "https://images.unsplash.com/photo-1596079890701-dd42edf0b7d4?auto=format&fit=crop&q=80",
      url: "/ogledala/irene"
    },
    {
      title: "Feel",
      imageSrc: "https://images.unsplash.com/photo-1603204077587-a3e570be71a9?auto=format&fit=crop&q=80",
      url: "/ogledala/feel"
    }
  ];

  return (
    <CategoryPage
      title="Ogledala"
      description="Odkrijte našo kolekcijo elegantnih ogledal, ki so oblikovana za popolno združitev estetike in funkcionalnosti."
      heroImage="https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80"
      subcategories={subcategories}
    />
  );
};

export default Ogledala;